/* eslint-disable */
// '@models/*'; doesn't work in jest for some reason TODO
import { AudioPlayerModel, createAudioPlayerModel } from './audio-player';
import { StoryblokAudioLibModel, createStoryblokAudioLibModel } from './storyblok-audio-lib';
import { StoryblokImageTargetTracksLibModel, createStoryblokImageTargetTracksLibModel } from './storyblok-image-target-lib';
import { QuizModel, createQuizModel } from './quiz';
import { GlobalModel, createGlobalModel } from './global';
import { VinylPostcardsModel, createVinylPostcardsModel } from './vinylpostcards';
import { Immutable } from './common';

export * from './global';
export * from './audio-player';
export * from './quiz';

export type Model = GlobalModel | AudioPlayerModel | QuizModel | StoryblokAudioLibModel | StoryblokImageTargetTracksLibModel | VinylPostcardsModel;

export type InferModelType<ModelType extends Model, Type extends Model['type']> = ModelType extends { type: Type } ? ModelType : never;
export type InferStateType<ModelType extends Model, Type extends Model['type']> = InferModelType<ModelType, Type> extends { state: Immutable<infer ModelType> }
  ? ModelType
  : undefined;

// there seems to be a bug with conditional types that's why everything is casted to any here,
// This should fix the bug hopefully: https://github.com/microsoft/TypeScript/pull/30639
export function createModel<ModelType extends Model, Type extends Model['type']>(
  type: Type,
  state?: InferStateType<ModelType, Type>
): InferModelType<ModelType, Type> {
  switch (type) {
    case 'AudioPlayerModel':
      return createAudioPlayerModel(state as any) as any;
    case 'QuizModel':
      return createQuizModel(state as any) as any;
    case 'StoryblokAudioLibModel':
      return createStoryblokAudioLibModel(state as any) as any;
    case 'StoryblokImageTargetTracksLibModel':
      return createStoryblokImageTargetTracksLibModel(state as any) as any;
    case 'VinylPostcardsModel':
      return createVinylPostcardsModel(state as any) as any;
    default: // should never occur but typescripts type inference is buggy...
    case 'GlobalModel':
      return createGlobalModel(state as any) as any;
  }
}
